import { Box, List, ListItem, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const AtsModalContent: FC = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Typography fontWeight={700} variant="body2">
        Extend ChangeEngine beyond employees to your hiring pipeline.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "ATS integration lets you connect ChangeEngine to your applicant tracking system, so you can manage communications with candidates without switching tools.",
        )}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Use it to:
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>
            Send consistent, branded messages to candidates at key hiring stages
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            Trigger onboarding and pre-start communications automatically
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            Keep candidates informed from offer to day one
          </ListItem>
        </List>
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "By linking your ATS with ChangeEngine, hiring teams can manage candidate communications alongside employee communications, using the same templates, targeting, and measurement.",
        )}
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        Fewer handoffs. Fewer tools. A smoother path from candidate to employee.
      </Typography>
    </Box>
  );
};
